import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-activate-deactivate-confirmation',
  templateUrl: './activate-deactivate-confirmation.component.html',
  standalone: false
})
export class ActivateDeactivateConfirmationComponent {

  constructor(
    public dialogRef: MatDialogRef<ActivateDeactivateConfirmationComponent>
  ) { }

  closeDialog() {
    this.dialogRef.close();
  }

}
